module.exports = __webpack_public_path__ + "img/pond-fall.6edca7d7.png";